// extracted by mini-css-extract-plugin
export default {"searchBlock":"SearchBlock_searchBlock__05JKW"};